module.exports = __webpack_public_path__ + "Flaticon.3b46e0f652c118b02448.eot";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/flaticon/Flaticon.eot
// module id = ../../../../../src/assets/vendors/base/fonts/flaticon/Flaticon.eot
// module chunks = styles